export type AutoSelectProgramSavedBaggage = Array<{ name?: string; value?: { type?: string; content?: unknown } }>;

export type AutoSelectEndpointOverrideInput = {
    baggage?: AutoSelectProgramSavedBaggage;
    featureToggles?: {
        enableAutoSelectProgramAdminSetting?: boolean;
        US2161518_Bypass_Dealer_Auto_Select_Setting?: boolean;
    };
    dealer?: { autoSelectProgramByDefault?: unknown };
};

export const MV_AUTO_SELECT_PROGRAM_SAVED_BAGGAGE_NAME = 'mv.autoSelectProgramSaved';

// Current Auto Select state, rewritten on every save. Not mv.autoSelectProgramSaved, which is a
// timestamp written once and never updated.
export const MV_AUTO_SELECT_STATE_BAGGAGE_NAME = 'mv.autoSelectState';
